<template>
	<div ref="pageWrapper" class="page-wrapper" :class="{ 'd-none': !isReady, 'scroll-up': isScrollingUp, 'scroll-down': isScrollingDown }">
		<TopNavigationV8 :page="routeName" @scrollTo="handleScrollTo" @toggleNav="handleToggleNav"/>
		<LandingV8Top
			class="landing-page-component"
			id="creator-store"
			:activeComponent="visibleComponentId === 'creator-store'"
			:header="pageContent?.heroHeader"
			:subHeader="pageContent?.heroSubHeader"
			:heroPhoneImageSrc="pageContent?.heroImage"
			:referrerName="referrerFullName"
			:replaceHero="pageContent?.replaceHero"
		/>
		<LandingV8Showcase class="landing-page-component" id="creators-showcase" :activeComponent="visibleComponentId === 'creators-showcase'" />
		<LandingV8Demo class="landing-page-component" id="creators-demo" :activeComponent="visibleComponentId === 'creators-demo'" />
		<LandingV8FeatureCards class="landing-page-component" @register="registerByEvent('creators-showcase')" id="feature-cards" :activeComponent="visibleComponentId === 'creators-showcase'" />
		<LandingV8SetupSteps class="landing-page-component alt-bg" id="setup" :activeComponent="visibleComponentId === 'setup'" />
		<LandingV8Pricing class="landing-page-component" @register="registerByEvent('creators-showcase')" id="pricing" :activeComponent="visibleComponentId === 'creators-showcase'" />
		<LandingV8Testimonials class="landing-page-component" id="people-saying" :activeComponent="visibleComponentId === 'people-saying'" />
		<LandingV8Trustpilot class="landing-page-component" @register="registerByEvent('creators-showcase')" id="trustpilot" :activeComponent="visibleComponentId === 'creators-showcase'" />
		<LandingV8ProductPerks class="landing-page-component" id="competitors" :activeComponent="visibleComponentId === 'competitors'" />
		<LandingV8Footer id="footer" class="" />
	</div>
</template>

<script setup>
	import { onMounted, nextTick, onUnmounted, ref, watch } from 'vue'
	import { useRoute } from 'vue-router'
	import { getIsMobile, isInView } from '@/plugins/is'
	import { useLandingPage } from '@/stores/landingPage'
	import LandingV8Showcase from '@/components/home/V8/LandingV8Showcase'
	import LandingV8Top from '@/components/home/V8/LandingV8Top'
	import LandingV8Testimonials from '@/components/home/V8/LandingV8Testimonials'
	import LandingV8ProductPerks from '@/components/home/V8/LandingV8ProductPerks'
	import LandingV8SetupSteps from '@/components/home/V8/LandingV8SetupSteps'
	import LandingV8Footer from '@/components/footer/FooterV8'
	import TopNavigationV8 from '../header/TopNavigationV8.vue'
	import LandingV8List from './V8/LandingV8List.vue'
	import LandingV8FeatureCards from '@/components/home/V8/LandingV8FeatureCards'
	import LandingV8Trustpilot from '@/components/home/V8/LandingV8Trustpilot'
	import LandingV8Pricing from '@/components/home/V8/LandingV8Pricing'
	import LandingV8Demo from '@/components/home/V8/LandingV8Demo'

	const landingPage = useLandingPage()
	const pageContent = landingPage.pageContent
	const hasReferrer = landingPage.hasReferrer
	const referrerFullName = landingPage.referrerFullName
	const trialDays = landingPage.trialDays
	const threeDayTrial = landingPage.threeDayTrial
	const route = useRoute()
	const routeName = route.name
	const callToActionButton = {
		'creator-store': {
			text: 'Create Your Store',
			background: '#FFFFFF',
			color: '#142658',
		},
		'product-highlights': {
			text: 'Create Your Store',
			background: '#142658',
			color: '#FFFFFF',
		},
		'creators-showcase': {
			text: 'Create Your Store',
			background: '#142658',
			color: '#FFFFFF',
		},
		'people-saying': {
			text: 'People saying',
			background: '#142658',
			color: '#FFFFFF',
		},
		competitors: {
			text: threeDayTrial ? 'Get 3 months for $1/mo' : `Try Stan ${trialDays} Days Free`,
			background: '#142658',
			color: '#FFFFFF',
		},
		setup: {
			text: threeDayTrial ? 'Get 3 months for $1/mo' : `Try Stan ${trialDays} Days Free`,
			background: '#142658',
			color: '#FFFFFF',
		},
	}

	const urlParams = new URLSearchParams(window.location.search)
	const myParam = urlParams.get('myParam')

	const handleScroll = () => {
		const st = window.pageYOffset || document.documentElement.scrollTop
		if (st > lastScrollTop.value) {
			document.body.classList.remove('scroll-up')
			document.body.classList.remove('scroll-about')
			document.body.classList.add('scroll-down')
		} else if (st < lastScrollTop.value) {
			document.body.classList.remove('scroll-down')

			if (myParam) {
				document.body.classList.remove('scroll-up')
				document.body.classList.add('scroll-about')
			} else {
				document.body.classList.remove('scroll-about')
				document.body.classList.add('scroll-up')
			}
		}
		lastScrollTop.value = st
	}

	const pageWrapper = ref(null)
	const isReady = ref(false)
	const pageScrollTop = ref(0)
	const scrollHandlerCount = ref(0)
	const visibleComponentId = ref('creator-store')
	const callToActionButtonText = ref('Create Your Store')
	const isMobile = ref(getIsMobile())

	const lastScrollTop = ref(0)
	const isScrollingUp = ref(false)
	const isScrollingDown = ref(false)

	const scrollHandler = ev => {
		if (scrollHandlerCount.value % 5 === 0) {
			let component
			for (let componentId of Object.keys(callToActionButton)) {
				component = document.getElementById(componentId)
				if (component) {
					try {
						const inViewPort = isInView(isMobile.value, component)
						if (inViewPort) {
							visibleComponentId.value = componentId
							document.documentElement.style.setProperty('--stan-fixed-button-background', callToActionButton[componentId].background)
							document.documentElement.style.setProperty('--stan-fixed-button-color', callToActionButton[componentId].color)

							callToActionButtonText.value = callToActionButton[componentId].text
							break
						}
					} catch (err) {
						console.error(err)
					}
				} else {
					console.log(`can't not get component: ${componentId}`)
				}
			}
		}
		scrollHandlerCount.value = (scrollHandlerCount.value + 1) % 5
	}

	onMounted(() => {
		document.addEventListener('scroll', handleScroll)

		setTimeout(() => {
			pageWrapper.value?.scrollTo(0, 0)
			nextTick(() => {
				isReady.value = true
			})
		}, 500)
	})

	onUnmounted(() => {
		pageWrapper.value?.removeEventListener('scroll', scrollHandler, false)
		document.removeEventListener('scroll', handleScroll)
	})

	watch(isMobile, val => {
		if (val && visibleComponentId.value === 'creator-store') {
			pageWrapper.value.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
		}
	})
	if (typeof window.clarity === 'function') {
		window.clarity('set','version','v8')
	}

	const handleScrollTo = (sectionId) => {
		const targetElement = document.getElementById(sectionId)
		if (targetElement) {
			const offsetTop = targetElement.offsetTop

			window.scrollTo({
				top: offsetTop,
				behavior: 'smooth'
			})
		}
	}


	const handleToggleNav = (isToggled) => {
		console.log('Navigation toggled:', isToggled)
	}


</script>

<style lang="scss" scoped>

	.scroll-about {
		background-color: black !important;
	}

	.page-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		overflow: visible;
		-ms-overflow-style: none; /* for Internet Explorer, Edge */
		scrollbar-width: 0;


		&::-webkit-scrollbar {
			display: none;
		}
	}

	.landing-page-component {
		width: 100vw;
		height: fit-content !important;
	}
	.alt-bg {
		background-color: var(--stan-alt-bg-color) !important;
	}
	.top-banner {
		background-color: var(--stan-positive-primary-color);
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-weight: 800;
		padding-inline: 32px;
		padding-block: 8px;
		position: sticky;
		z-index: 11;
		text-align: center;
		display: none;
		@media screen and (max-width: 767px) {
			font-size: 14px;
		}
	}
</style>
